export const getBannerCookie = (cookies: string) => {
  return cookies
    .split('; ')
    .find((row) => row.startsWith('privacyBannerOpened='))
    ?.split('=')[1]
}
